/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Použít`
};

const da_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Anvend`
};

const de_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Anwenden`
};

const en_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Apply`
};

const es_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Aplicar`
};

const fr_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Appliquer`
};

const hu_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Alkalmaz`
};

const it_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Applica`
};

const nl_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Toepassen`
};

const pl_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Zastosuj`
};

const pt_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Aplicar`
};

const sv_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Tillämpa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const apply = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.apply(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("apply", locale)
	if (locale === "cs") return cs_apply(inputs)
	if (locale === "da") return da_apply(inputs)
	if (locale === "de") return de_apply(inputs)
	if (locale === "en") return en_apply(inputs)
	if (locale === "es") return es_apply(inputs)
	if (locale === "fr") return fr_apply(inputs)
	if (locale === "hu") return hu_apply(inputs)
	if (locale === "it") return it_apply(inputs)
	if (locale === "nl") return nl_apply(inputs)
	if (locale === "pl") return pl_apply(inputs)
	if (locale === "pt") return pt_apply(inputs)
	return sv_apply(inputs)
};